import { render } from "./MdcForm.vue?vue&type=template&id=a01b4ff6"
import script from "./MdcForm.vue?vue&type=script&lang=js"
export * from "./MdcForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__